import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import HeaderRegionMake from 'js/containers/header-region/HeaderRegion.make';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import ContentItemGrid from 'js/components/content-item/ContentItem.grid';
import FilterGridIndex from 'js/components/filter-grid/FilterGrid.index';

// import actions
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';

// import selectors
import { getFeaturedMakes, getAllMakes } from '../store/makes/Makes.selectors';

import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

const PageMake = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.home]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.make);
  });

  const featuredMakes = useSelector((state) => {
    return getFeaturedMakes(state);
  });

  useEffect(() => {
    trackPageview({ title: PAGE_IDS.make, path: props.path });
  }, []);

  const {
    header: {
      title = 'Make',
      description = 'A little introduction to the craft section. Spring migration, identified she raptor. Big sit raptor, perching, primaries below Audubon.',
      image = '',
    } = {},
  } = pageData;

  return (
    <>
      <SiteMetaData {...meta} />
      <HeaderRegionMake title={title} description={description} image={image} />
      <div className="make--content-grid">
        <SvgTextureLineLong color={'#936888'} />
        <div className="container">
          <ContentItemGrid title="New Activities For You" twoHero data={featuredMakes} type={'make'} />
        </div>
      </div>
      <div className="make--filter-grid">
        <div className="container">
          <FilterGridIndex title="All Activities" type={'makes'} />
        </div>
      </div>
    </>
  );
};

export default PageMake;
